import {
	handleActions
} from 'redux-actions';
import Immutable from 'immutable';

const PhotoListState = Immutable.fromJS({
	previousPage: '/',
	card: null,
	clothesPrePhotoList: [],
	pantPrePhotoList: [],
	clothesPostPhotoList: [],
	pantPostPhotoList: [],
});

const photoListReducer = handleActions({
	FIND_PHOTO_LIST: (state, { payload }) => {
		return state.merge({
			card: payload.data.card,
			clothesPrePhotoList: payload.data.clothesPrePhotoList,
			pantPrePhotoList: payload.data.pantPrePhotoList,
			clothesPostPhotoList: payload.data.clothesPostPhotoList,
			pantPostPhotoList: payload.data.pantPostPhotoList
		})
	},
	CHANGE_PHOTO_LIST_PREVIOUS_PAGE: (state, { payload }) => {
		return state.merge({
			previousPage: payload
		})
	}
}, PhotoListState);

export default photoListReducer;


// WEBPACK FOOTER //
// ./src/reducers/photoListReducer.js